<div class="d-block d-lg-none">
  <fgb-page-header [pageTitle]="'wallet.claimed.page.title'" [showBalance]="false" [showQr]="false"></fgb-page-header>
</div>

<div class="container pt-4 pt-lg-0">
  <a
    class="back-btn text-primary cursor-pointer d-none d-lg-flex align-items-center justify-content-center"
    [routerLink]="'/rewards/wallet'"
  >
    <span class="material-symbols-outlined ms-2 text-white"> arrow_back_ios </span>
  </a>

  <!-- Offer history -->
  <ng-container *ngIf="campaignOffers$ | async as featuredCampaigns">
    <ng-container *ngIf="hasOfferItems">
      <h5 class="m-0 wallet-redeemed-title pb-2 pt-3">
        {{ 'wallet.redeemed.offers.history.title' | translate }}
      </h5>
      <div class="mb-4">
        <fgbcl-campaigns-offers-used-list
          [usedOffers]="featuredCampaigns.CampaignsAndEntitlements"
        ></fgbcl-campaigns-offers-used-list>
      </div>
    </ng-container>
  </ng-container>

  <!-- Items history -->
  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async,
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
      <h5 class="m-0 wallet-redeemed-title pb-2 pt-3">
        {{ 'wallet.redeemed.item.history.title' | translate }}
      </h5>
      <fgbcl-rewards-wallet-redeemed-list [redeemedItems]="walletItems.walletItemsClaimed"></fgbcl-rewards-wallet-redeemed-list>
    </ng-container>
  </ng-container>

  <ng-template #noWalletItems
    ><div class="no-claim-container bg-white">
      <div class="fw-bold font-size-12 text-center text-grey py-3">
        {{ 'claimed.rewards.placeholder.description' | translate }}
      </div>
    </div>
  </ng-template>
</div>
